<template lang="pug">
div.course-item
  slot
  p.course-item__title  {{ course._date | formattedDateWithDDD }} 
    template(v-if="course.date && course.name") - 
    | {{ course.name }}
  course-counts(:item="course").course-item__counts
  
</template>

<script>
export default {
  props: {
    activeItems: Array,
    course: Object
  },

  components: {
    courseCounts: () => import('@/app/admin/modules/course_managment/components/СMCourseCounts.vue')
  }
}
</script>

<style lang="scss" scoped>
.course-item {
  display:flex;
  align-items: center;
  &__title {
    margin-bottom: 0;
    width: 200px;
  }
  &__counts {
    flex-grow: 1;
  }
}
</style>